import './reservationDeduplicator.scss'
import { ReservationFormValidator } from '@/modules/datalayer/ReservationForm'

/**
 * @param {HTMLInputElement} button
 */
function blockSubmitButton (button) {
  // This is a flag that when set to true the form will not go through with submission
  // It is done to prevent re-submission when the form is submitted using Enter key
  // instead of just pressing the "REZERWUJ ONLINE" button
  let submitting = false

  return function(e) {
    if (!new ReservationFormValidator(button.form).isFormValid()) {
      return
    }

    if (submitting) {
      e.stopPropagation()
      e.preventDefault()
      return
    }

    submitting = true
    button.value = 'TRWA PRZETWARZANIE DANYCH...'
    button.parentElement.classList.add('btn-cta--disabled')
    button.disabled = true
  }
}
export function init () {
  document.querySelectorAll('.payment-summary input[type="submit"]').forEach(submit => {
    submit.form.addEventListener('submit', blockSubmitButton(submit))
  })
}



// WEBPACK FOOTER //
// ./src/modules/customizations/reservationDeduplicator.js